import React, { useEffect, useState } from "react";

const emptyForm = {
  name: "",
  anonymous: false,
  title: "",
  story: "",
};

export default function StoryUploadForm({ onSaveStory, isAdmin, editingStory = null }) {
  const [formData, setFormData] = useState(emptyForm);

  useEffect(() => {
    if (editingStory) {
      setFormData({
        name: editingStory.name || "",
        anonymous: editingStory.anonymous || false,
        title: editingStory.title || "",
        story: editingStory.story || "",
      });
    } else {
      setFormData(emptyForm);
    }
  }, [editingStory]);

  function handleChange(event) {
    const { name, value, type, checked } = event.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  }

  async function handleSubmit(event) {
    event.preventDefault();
    await onSaveStory({
      name: formData.name,
      anonymous: formData.anonymous,
      title: formData.title,
      story: formData.story,
    });
    if (!editingStory) {
      setFormData(emptyForm);
    }
  }

  if (!isAdmin) return null;

  return (
    <div className="form-card">
      <h3>{editingStory ? "Edit Story of Hope" : "Add Story of Hope"}</h3>

      <form className="form-grid" onSubmit={handleSubmit}>
        <div>
          <label className="label" htmlFor="story-name">Name</label>
          <input
            className="input"
            id="story-name"
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            disabled={formData.anonymous}
          />
        </div>

        <label>
          <input
            type="checkbox"
            name="anonymous"
            checked={formData.anonymous}
            onChange={handleChange}
          />{" "}
          Anonymous
        </label>

        <div>
          <label className="label" htmlFor="story-title">Story Title</label>
          <input
            className="input"
            id="story-title"
            type="text"
            name="title"
            value={formData.title}
            onChange={handleChange}
            required
          />
        </div>

        <div>
          <label className="label" htmlFor="story-text">Story</label>
          <textarea
            className="textarea"
            id="story-text"
            name="story"
            value={formData.story}
            onChange={handleChange}
            required
          />
        </div>

        <button className="btn btn-primary" type="submit">
          {editingStory ? "Update Story" : "Save Story"}
        </button>
      </form>
    </div>
  );
}
